export default function ComingSoon() {
  return <span className="fst-italic">coming soon!</span>;
}
